import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import TaskSkeleton from "./TaskSkeleton";

export default function AgentReport() {
    const { http, user } = AuthUser();
    const navigate = useNavigate();
    const [tasks, setTasks] = useState([]);
    
    // Set flag in sessionStorage when component mounts to track navigation to duelist
    useEffect(() => {
        sessionStorage.setItem('fromAgentReport', 'true');
        return () => {
            // Optionally clear on unmount if needed
        };
    }, []);
    const [date, setDate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [remark, setRemark] = useState(null);
    const [departments, setdepartments] = useState([]);
    const [currentStatus, setCurrentStatus] = useState(null);
    const [loginUser, setloginUser] = useState(user.department_id);
    const [editColumn, setEditColumn] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [editUser, setEditUser] = useState({});
    useEffect(() => {
        fetchTaskDetails();
    }, []);

    const fetchTaskDetails = () => {
        setIsLoading(true);
        let endpoint = `/agent_report?company_id=${user.company_id}`;

        http
            .get(endpoint)
            .then((res) => {
                setIsLoading(false);
                if (Array.isArray(res.data.data)) {
                    setTasks(res.data.data);
                } else {
                    setIsLoading(false);
                    console.error("API response is not an array");
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error fetching tasks:", error);
            });
    };

    const statusUpdate = (e) => {
        setCurrentStatus(e.target.value);
    };

    const saveEditedCustemer = async (e) => {
        e.preventDefault();
        try {
            if (!editUser) {
                // Handle the case when editUser is null
                console.error("No user data to edit.");
                return;
            }
            const response = await http.put(`/agent_edit/${editUser.id}`, formData1);
            if (Array.isArray(response.data.data)) {
                toast.success("agent updated successfully!");
                setShowModal(false);
                fetchTaskDetails();
            } else {
                console.log("API response is not an array");
            }
        } catch (error) {
            console.error("Error updating user", error);
            toast.error("An error occurred while updating the customer.");
        }
        setEditColumn("");
    };

    const handleSave = async (taskId) => {
        if (currentStatus === null || taskId === null) {
            toast.error("Please select proper status");
            return true;
        }
        try {
            const response = await http.put(
                `task_status_update?task_id=${taskId}&status=${encodeURIComponent(
                    currentStatus
                )}`
            );
            toast.success("Task status updated successfully !");
            fetchTaskDetails();
        } catch (error) {
            console.error("Error fetching tasks:", error);
            toast.error("Please select proper item");
        }
    };

    const initialState = {
        name: "",
    };

    const handleChangeModal = (e) => {
        setFormData1({
            ...formData1,
            [e.target.name]: e.target.value,
        });
    };

    const deleteTask = async (taskId) => {
        console.log(taskId);
        await http
            .delete(`/departments_del/${taskId}`)
            .then((response) => {
                toast.success("Departments Deleted successfully !");
                fetchTaskDetails();
            })
            .catch((err) => {
                console.error("Error deleting task", err);
            });
    };

    const openEditModal = async (taskAll) => {
        setShowModal(true);
        setFormData1({
            name: taskAll.name || "",
            amount: taskAll.amount || "",
        });
        setEditUser(taskAll);
    };

    const [formData1, setFormData1] = useState({
        name: "",
        amount: "",
    });

    const closeModal = () => {
        setShowModal(false);
        setEditColumn("");
    };

    // Group tasks by year
    const groupByYear = (data) => {
        const grouped = {};
        data.forEach(task => {
            const year = task.ext_2 || 'No Year';
            if (!grouped[year]) {
                grouped[year] = [];
            }
            grouped[year].push(task);
        });
        return grouped;
    };

    // Sort years descending (newest first like "2025-26" before "2024-25")
    const sortYears = (years) => {
        return years.sort((a, b) => {
            if (a === 'No Year') return 1;
            if (b === 'No Year') return -1;
            const yearA = parseInt(a.split('-')[0]) || 0;
            const yearB = parseInt(b.split('-')[0]) || 0;
            return yearB - yearA; // Descending order (newest first)
        });
    };

    // Filter agents with A/C in name
    const regularAgents = tasks.filter(task => !task.agent_name || !task.agent_name.includes('A/C'));
    const acAgents = tasks.filter(task => task.agent_name && task.agent_name.includes('A/C'));

    // Group regular and AC agents by year
    const regularAgentsByYear = groupByYear(regularAgents);
    const acAgentsByYear = groupByYear(acAgents);

    // Get sorted year keys
    const regularYears = sortYears(Object.keys(regularAgentsByYear));
    const acYears = sortYears(Object.keys(acAgentsByYear));

    // Calculate totals for a group
    const calculateTotals = (agents) => {
        return {
            totalStudents: agents.reduce((sum, a) => sum + (parseInt(a.unique_student_count) || 0), 0),
            totalListed: agents.reduce((sum, a) => sum + (parseFloat(a.total_ext_17) || 0), 0),
            totalAmount: agents.reduce((sum, a) => sum + (parseFloat(a.total_amount) || 0), 0),
        };
    };

    return (
        <>
            <Toaster />
            {showModal && (
                <form onSubmit={saveEditedCustemer}>
                    <div className="modal" tabindex="-1" style={{ display: "block" }}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Edit</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={closeModal}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group  mt-3">
                                        <label> Name </label>
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control"
                                            value={formData1.name}
                                            onChange={handleChangeModal}
                                        />
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={closeModal}
                                    >
                                        Close
                                    </button>
                                    <button type="submit" className="btn btn-primary">
                                        Save changes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            )}

            <div className="container mt-1">
                <div className="row">
                    <h1>Consultant Report</h1>
                </div>

                <div className="table-responsive">
                    {isLoading ? (
                        <TaskSkeleton />
                    ) : (
                        <>
                            {/* Year-wise tables for regular agents */}
                            {regularYears.length > 0 ? (
                                regularYears.map((year) => {
                                    const yearAgents = regularAgentsByYear[year];
                                    const totals = calculateTotals(yearAgents);
                                    return (
                                        <div key={year} className="mb-4">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <h5 className="mb-0">
                                                    <span className="badge bg-primary me-2">{year}</span>
                                                    <small className="text-muted">({yearAgents.length} agents)</small>
                                                </h5>
                                            </div>
                                            <table className="table table-striped table-bordered table-simple">
                                                <thead>
                                                    <tr>
                                                        <th style={{width:'5%'}}>No</th>
                                                        <th style={{width:'30%'}}>Name</th>
                                                        <th style={{width:'15%'}}>Total Students</th>
                                                        <th style={{width:'15%'}}>Listed Amount</th>
                                                        <th style={{width:'15%'}}>Amount (Total)</th>
                                                        <th style={{width:'15%'}}>Difference</th>
                                    </tr>
                                </thead>
                                <tbody>
                                                    {yearAgents.map((taskuser, index) => (
                                            <tr key={taskuser.id}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    {taskuser.agent_name}
                                                    {taskuser.agent_name && (
                                                        <Link
                                                            to="/duelist"
                                                            state={{ agentName: taskuser.agent_name, fromAgentReport: true }}
                                                            className="ms-2"
                                                            title="View Due List for this Agent"
                                                            style={{ textDecoration: 'none' }}
                                                        >
                                                            <i className="fas fa-link text-primary"></i>
                                                        </Link>
                                                    )}
                                                </td>
                                                <td>{taskuser.unique_student_count}</td>
                                                <td>{taskuser.total_ext_17}</td>
                                                <td>{taskuser.total_amount}</td>
                                                <td>{taskuser.total_ext_17 - taskuser.total_amount}</td>
                                            </tr>
                                                    ))}
                                                </tbody>
                                                <tfoot>
                                        <tr>
                                                        <td colSpan="2"><strong>Total ({year})</strong></td>
                                                        <td><strong>{totals.totalStudents}</strong></td>
                                                        <td><strong>{totals.totalListed}</strong></td>
                                                        <td><strong>{totals.totalAmount}</strong></td>
                                                        <td><strong>{totals.totalListed - totals.totalAmount}</strong></td>
                                        </tr>
                                                </tfoot>
                            </table>
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="alert alert-info">No agents found</div>
                            )}

                            {/* Year-wise tables for A/C agents */}
                            {acYears.length > 0 && (
                                <>
                                    <hr className="my-4" />
                                    <h4 className="mb-3">A/C Agents</h4>
                                    {acYears.map((year) => {
                                        const yearAgents = acAgentsByYear[year];
                                        const totals = calculateTotals(yearAgents);
                                        return (
                                            <div key={`ac-${year}`} className="mb-4">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <h5 className="mb-0">
                                                        <span className="badge bg-secondary me-2">{year}</span>
                                                        <small className="text-muted">({yearAgents.length} agents)</small>
                                                    </h5>
                                                </div>
                                                <table className="table table-striped table-bordered table-simple">
                                                    <thead>
                                                        <tr>
                                                            <th style={{width:'5%'}}>No</th>
                                                            <th style={{width:'30%'}}>Name</th>
                                                            <th style={{width:'15%'}}>Total Students</th>
                                                            <th style={{width:'15%'}}>Listed Amount</th>
                                                            <th style={{width:'15%'}}>Amount (Total)</th>
                                                            <th style={{width:'15%'}}>Difference</th>
                                </tr>
                            </thead>
                            <tbody>
                                                        {yearAgents.map((taskuser, index) => (
                                    <tr key={taskuser.id}>
                                        <td>{index + 1}</td>
                                                    <td>
                                                        {taskuser.agent_name}
                                                        {taskuser.agent_name && (
                                                            <Link
                                                                to="/duelist"
                                                                state={{ agentName: taskuser.agent_name, fromAgentReport: true }}
                                                                className="ms-2"
                                                                title="View Due List for this Agent"
                                                                style={{ textDecoration: 'none' }}
                                                            >
                                                                <i className="fas fa-link text-primary"></i>
                                                            </Link>
                                                        )}
                                                    </td>
                                        <td>{taskuser.unique_student_count}</td>
                                        <td>{taskuser.total_ext_17}</td>
                                        <td>{taskuser.total_amount}</td>
                                        <td>{taskuser.total_ext_17 - taskuser.total_amount}</td>
                                    </tr>
                                ))}
                            </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td colSpan="2"><strong>Total ({year})</strong></td>
                                                            <td><strong>{totals.totalStudents}</strong></td>
                                                            <td><strong>{totals.totalListed}</strong></td>
                                                            <td><strong>{totals.totalAmount}</strong></td>
                                                            <td><strong>{totals.totalListed - totals.totalAmount}</strong></td>
                                                        </tr>
                                                    </tfoot>
                        </table>
                                            </div>
                                        );
                                    })}
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
        </>
    );
}
